export default "__VITE_ASSET__8dea796d__"